import { getCmsDestinationDetailAction } from "../../../Actions/LogicActions/CmsDestination/GetCMSDestinationDetailAction";
import { getBestPriceForDateRangeAction } from "../../../Actions/LogicActions/Search/GetBestPriceForDateRangeAction";
import { uiPreferencesAction } from "../../../Actions/LogicActions/Search/GetUIPreferencesAction";
import { destinationBookNowAction } from "../../../Actions/UIActions/CMSDestination/DestinationBookNowAction";
import { destinationReadMoreClickAction } from "../../../Actions/UIActions/CMSDestination/DestinationReadMoreAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import {
  ICMSBookNowParams,
  IGetDestinationActionParams,
} from "../../../Orchestrator/Types/Interface/ICmsDestination";

class DestinationDetailInitStep extends StepFlow {
  get stepName() {
    return "DestinationDetailInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<IGetDestinationActionParams, void>({
        eventName: evtTree.DestinationDetail.Get,
        handler: async ({ data }) => {
          if (data?.slug) {
            getCmsDestinationDetailAction.setParams(data!);
            getCmsDestinationDetailAction.execute();
          }
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<{ startStop: string, endStop: string }, void>({
        eventName: evtTree.SelectDateModal.Open,
        handler: async ({ data }) => {
          if (data) {
            const { startStop, endStop } = data;

            await uiPreferencesAction.execute();
            let calendarDayInterval = uiPreferencesAction.result?.calendarDayInterval || 90

            getBestPriceForDateRangeAction.setParams({
              from: startStop,
              to: endStop,
              type: TrainTypeEnum.outbound,
              calendarDayInterval
            })
            await getBestPriceForDateRangeAction.execute();
          }
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<ICMSBookNowParams, void>({
        eventName: evtTree.DestinationDetail.BookNow.Click,
        handler: async ({ data }) => {
          if (data) {
            destinationBookNowAction.setParams(data!);
            destinationBookNowAction.execute();
          }
        },
      })
    );
       this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.DestinationDetail.ReadMore.Click,
        handler: async (data) => {
          destinationReadMoreClickAction.setParams(data.data!);
          await destinationReadMoreClickAction.execute();
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("Destination detail Init Step Execute...");

    // Execute the action to fetch CMS DestinationDetail
  }
}

export const DestinationDetailInitStepDeclaration = new StepDefinition({
  stepName: "DestinationDetailInit_Step",
  stepClass: DestinationDetailInitStep,
});
